import styled from 'styled-components';
import ResponsiveContainer from '../Layout/ResponsiveContainer';

const BannerContainer = styled(ResponsiveContainer)`
  padding-top: ${({ theme }) => theme.padding.medium}px;
  padding-bottom: ${({ theme }) => theme.padding.medium}px;
`;

export default BannerContainer;
